import React, { Fragment, useState, useEffect } from "react";
import { Button, Col, Glyphicon } from "react-bootstrap";

import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";

import { Panel, PanelHeader } from "../../Panel";
import { RemoteGrid } from "../../Grid/RemoteGrid";
import { Filters, Filter } from "../../Filter";
import { DetailsModal } from "./DetailsModal";
import { ActivityConfigColumn, Order, Operation } from "../../../constant";

import { DateRangeConfig } from "../../../components/Filter/config";

const initialDates = DateRangeConfig.DEFAULT_DATERANGE;

export const defaultActivities = [
  { id: 0, name: "All" },
  { id: 1, name: "Added" },
  { id: 2, name: "Modified" },
  { id: 3, name: "Deleted" },
];

export function ActivityLogs({
  onFetchActivityLogs,
  onBackMainPage,
  activityLogFilters,
  backButtonLabel,
  detailsModalHeader,
  extraColumns,
  extraSortColumns,
  hasActivityFilter,
  activities,
}) {
  const columns = [
    {
      dataField: "id",
      text: "Id",
      hidden: true,
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => cell,
    },
    {
      dataField: "date",
      text: "Date",
      sort: true,
      searchable: false,
      formatter: (cell, row) => moment(cell).format("LLL"),
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => moment(cell).format("LLL"),
    },
    {
      dataField: "activity",
      text: "Activity",
      sort: true,
      searchable: false,
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => cell,
    },
    {
      dataField: "user",
      text: "User",
      sort: true,
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => cell,
    },
    ...extraColumns,
    {
      dataField: "buttons",
      text: "",
      align: "center",
      formatter: (cell, row) => (
        <Button
          bsStyle="primary"
          title="View Activity Log Details"
          onClick={() => handleLogDetails(row)}
        >
          <Glyphicon glyph="eye-open" />
        </Button>
      ),
    },
  ];
  const activityOptions = activities ? activities : defaultActivities;

  // search states
  const [searchCriteria, setSearchCriteria] = useState({
    searchBy: 0,
    searchText: "",
    operation: Operation.EQUAL,
  });

  // grid states
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  const [sortColumns, setSortColumns] = useState(ActivityConfigColumn);
  const [order, setOrder] = useState({
    sortBy: sortColumns.date,
    orderBy: Order.desc,
  });
  const [logs, setLogs] = useState({
    items: [],
    totalRows: 0,
  });

  // filter states
  const [selectedActivity, setSelectedActivity] = useState(0);
  const [date, setDate] = useState(initialDates);

  // log details states
  const [selectedLog, setSelectedLog] = useState({});
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  useEffect(() => {
    if (extraSortColumns) {
      setSortColumns({ ...sortColumns, ...extraSortColumns });
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    onFetchActivityLogs(
      date.startDate,
      date.endDate,
      pagination.currentPage,
      pagination.pageSize,
      order.sortBy,
      order.orderBy,
      searchCriteria.searchText,
      selectedActivity,
      searchCriteria.searchBy,
      searchCriteria.operation
    ).then((res) => {
      setLogs(res);
      setLoading(false);
    });
  }, [
    date.startDate,
    date.endDate,
    pagination.currentPage,
    pagination.pageSize,
    order.sortBy,
    order.orderBy,
    searchCriteria.searchText,
    selectedActivity,
    searchCriteria.searchBy,
    searchCriteria.operation,
  ]);

  const handleSearch = (searchCriteria) => {
    setPagination({
      currentPage: 1,
      pageSize: pagination.pageSize,
    });
    setSearchCriteria({ ...searchCriteria });
  };

  const handleTableOrderPaginationChanges = (type, state) => {
    const currentPage = state.page;
    const pageSize = state.sizePerPage;
    const sortBy = sortColumns[state.sortField];
    const orderBy = Order[state.sortOrder];

    setPagination({
      currentPage: currentPage,
      pageSize: pageSize,
    });
    setOrder({
      sortBy: sortBy,
      orderBy: orderBy,
    });
  };

  const handleActivityFilterChange = (state) => {
    setPagination({
      currentPage: 1,
      pageSize: pagination.pageSize,
    });
    setSelectedActivity(state.activity.value);
    setDate({
      startDate: state.dateRange.value.startDate,
      endDate: state.dateRange.value.endDate,
    });
  };

  const toggleDetailsModal = () => {
    setShowDetailsModal(!showDetailsModal);
  };

  const handleLogDetails = (row) => {
    setSelectedLog(row);
    toggleDetailsModal();
  };

  return (
    <Fragment>
      <Col md={10} mdPush={2}>
        <Panel>
          <PanelHeader>
            <Button bsSize="small" bsStyle="primary" onClick={onBackMainPage}>
              <Glyphicon glyph="cog" /> {backButtonLabel}
            </Button>
          </PanelHeader>
          <div className="panel-body">
            <RemoteGrid
              filterFields={activityLogFilters}
              columns={columns}
              data={logs}
              loading={loading}
              pagination={pagination}
              onTableChange={handleTableOrderPaginationChanges}
              onSearch={handleSearch}
              defaultSorted={[
                {
                  dataField: "date",
                  order: "desc",
                },
              ]}
            />
          </div>
        </Panel>
      </Col>
      <Filters
        hasDateRange
        className="col-md-2 col-md-pull-10"
        initialValues={{ activity: { text: "", value: 0 } }}
        onFilterValueChange={handleActivityFilterChange}
      >
        {hasActivityFilter && (
          <Filter name="activity" title="Activity" options={activityOptions} />
        )}
      </Filters>
      <DetailsModal
        show={showDetailsModal}
        selectedLog={selectedLog}
        detailsModalHeader={detailsModalHeader}
        onModalClose={toggleDetailsModal}
      />
    </Fragment>
  );
}
